import { Controller } from "@hotwired/stimulus"

// Makes a <tr> act like a link by forwarding clicks to its first nested
// anchor. Ignores clicks on interactive elements so in-row links, buttons,
// inputs, labels, and selects keep their own behaviour.
export default class extends Controller {
  navigate(event) {
    if (event.target.closest("a, button, input, select, label, [data-row-link-ignore]")) return
    const link = this.element.querySelector("a[href]")
    if (link) link.click()
  }
}
